const SURA = 'SURA';
const ANSWER = 'ANSWER';
const AFFINITY = 'affinity';
const SURA_EMPLOYEES = 'sura_employees';

export { SURA, ANSWER, AFFINITY, SURA_EMPLOYEES };
